import script from "./orderSelectedPop.vue?vue&type=script&setup=orderSelectedPop&lang=js"
export * from "./orderSelectedPop.vue?vue&type=script&setup=orderSelectedPop&lang=js"

const __exports__ = script;

export default __exports__